exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-53dddaae] .el-upload-dragger{width:400px;height:100px}[data-v-53dddaae] .el-upload__tip{width:400px}[data-v-53dddaae] .el-icon-upload{margin-top:7px}[data-v-53dddaae] .el-upload-list__item-name{white-space:normal!important}", ""]);

// exports
